import { render, staticRenderFns } from "./PageTitleBar.vue?vue&type=template&id=0f03cd78&scoped=true&"
import script from "./PageTitleBar.vue?vue&type=script&lang=ts&"
export * from "./PageTitleBar.vue?vue&type=script&lang=ts&"
import style0 from "./PageTitleBar.vue?vue&type=style&index=0&id=0f03cd78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f03cd78",
  null
  
)

export default component.exports